import { render, staticRenderFns } from "./shareOrder7.vue?vue&type=template&id=35508fa2&scoped=true&"
import script from "./shareOrder7.vue?vue&type=script&lang=js&"
export * from "./shareOrder7.vue?vue&type=script&lang=js&"
import style0 from "./shareOrder7.vue?vue&type=style&index=0&id=35508fa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35508fa2",
  null
  
)

export default component.exports